import { render, staticRenderFns } from "./FooterContent.vue?vue&type=template&id=4c50b9ec&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FooterContent.vue"
export default component.exports